import React from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const AppBlock = ({className, compactView, dispatch, ...props}) => (
  <div
    {...props}
    className={classNames('app-block', {'app-block--small': compactView}, className)}
  />
);

AppBlock.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  compactView: PropTypes.bool.isRequired,
  dispatch: PropTypes.func
};

function mapStateToProps(state) {
  return {
    compactView: state.xl.compactView
  };
}

export default connect(mapStateToProps)(AppBlock);



// WEBPACK FOOTER //
// ./components/AppBlock.jsx